module.exports = __webpack_public_path__ + "img/honey-lime-dressing.a4f37cb7.jpg";